import { defineComponent as _defineComponent } from 'vue';
import AzIcon from '~/components/_next/atoms/AzIcon.vue';
export default /*#__PURE__*/_defineComponent({
  __name: 'ToolTip',
  props: {
    iconName: {
      default: 'info-circle'
    },
    enableMouseEnter: {
      type: Boolean,
      default: true
    },
    enableMouseLeave: {
      type: Boolean
    },
    enableClick: {
      type: Boolean
    }
  },
  setup: function setup(__props) {
    var props = __props;
    var isTooltipVisible = ref(false);
    var _useUiState = useUiState(),
      isCartSidebarOpen = _useUiState.isCartSidebarOpen;
    var handleMouseEnter = function handleMouseEnter() {
      if (props.enableMouseEnter) {
        isTooltipVisible.value = true;
      }
    };
    var handleMouseLeave = function handleMouseLeave() {
      if (props.enableMouseEnter || props.enableMouseLeave) {
        isTooltipVisible.value = false;
      }
    };
    var handleClick = function handleClick() {
      if (props.enableClick) {
        isTooltipVisible.value = !isTooltipVisible.value;
      }
    };
    var iconColor = computed(function () {
      return isTooltipVisible.value ? 'var(--c-primary-500)' : 'var(--c-primary-800)';
    });
    watch(function () {
      return isCartSidebarOpen.value;
    }, function (newValue) {
      if (newValue) isTooltipVisible.value = false;
    });
    watch(function () {
      return props.enableClick;
    }, function (newValue) {
      if (!newValue) {
        isTooltipVisible.value = false;
      }
    });
    return {
      __sfc: true,
      props: props,
      isTooltipVisible: isTooltipVisible,
      isCartSidebarOpen: isCartSidebarOpen,
      handleMouseEnter: handleMouseEnter,
      handleMouseLeave: handleMouseLeave,
      handleClick: handleClick,
      iconColor: iconColor,
      AzIcon: AzIcon
    };
  }
});